import { useEditorStore } from '../store/editor'

// 编辑器读写当前场景数据。
// update(fn) 用 immer draft 修改 data；每次修改进 undo 栈（zundo 自动）。
export function useSceneData() {
  const data = useEditorStore((s) => s.data)
  const mutate = useEditorStore((s) => s.mutateData)
  // fn 收到宽松 draft（场景内部按需断言）；不在 hook 侧强类型，避免每个场景写一堆 cast。
  const update = (fn: (draft: any) => void) => mutate((d) => fn(d as any))
  return { data, update }
}
